// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"b307c898","338":"1ed8d2d2","628":"b307c898","641":"0cec10fd"}[chunkId] + ".css";
};